/**
 * Custom Variant Selector - Updates hidden variant input when options change
 */

document.addEventListener('DOMContentLoaded', () => {
  console.log('🔧 Custom variant selector initialized');

  // Find all product forms (try multiple selectors)
  const forms = document.querySelectorAll('form.shopify-product-form, form[data-product-form], form[action*="/cart/add"]');

  console.log('📋 Found', forms.length, 'product forms');

  forms.forEach((form, formIndex) => {
    console.log(`\n🔍 Checking form ${formIndex + 1}...`);

    const hiddenInput = form.querySelector('input[name="id"]');
    const selects = form.querySelectorAll('select[data-option-selector], select[name^="options"]');

    if (!hiddenInput) {
      console.warn('⚠️ No hidden variant input found in form');
      return;
    }

    console.log('✅ Found variant form with hidden input:', hiddenInput.value);
    console.log('📋 Found', selects.length, 'variant selectors');

    // Get product data from form
    const productId = form.querySelector('input[name="product-id"]')?.value;

    if (!productId) {
      console.warn('⚠️ No product ID found');
      return;
    }

    console.log('🏷️ Product ID:', productId);

    // Listen to all variant selects
    selects.forEach((select, index) => {
      console.log(`   Select ${index + 1}: ${select.name} = ${select.value}`);

      select.addEventListener('change', async () => {
        console.log('🔄 Variant option changed:', select.name, '=', select.value);

        // Get all selected options
        const selectedOptions = Array.from(selects).map(s => s.value);
        console.log('📦 All selected options:', selectedOptions);

        // Fetch product data to find matching variant
        try {
          // Try to get product handle or use ID
          const productHandle = form.closest('[data-product-handle]')?.dataset.productHandle ||
                                window.location.pathname.split('/products/')[1]?.split('?')[0] ||
                                productId;

          console.log('🔍 Fetching product:', productHandle);

          const response = await fetch(`/products/${productHandle}.js`);
          const product = await response.json();

          console.log('📦 Product data:', product);
          console.log('📦 Available variants:', product.variants);

          // Find variant that matches all selected options
          const matchingVariant = product.variants.find(variant => {
            const variantOptions = [variant.option1, variant.option2, variant.option3].filter(Boolean);
            return selectedOptions.every((opt, i) => opt === variantOptions[i]);
          });

          if (matchingVariant) {
            console.log('✅ Found matching variant:', matchingVariant.id, matchingVariant.title);
            console.log('   Old hidden input value:', hiddenInput.value);
            hiddenInput.value = matchingVariant.id;
            console.log('   New hidden input value:', hiddenInput.value);

            // Update price if exists
            const priceDisplay = document.querySelector('[data-price-display]');
            if (priceDisplay && matchingVariant.price) {
              const price = (matchingVariant.price / 100).toFixed(2);
              priceDisplay.textContent = `$${price}`;
              console.log('💰 Updated price to:', price);
            }
          } else {
            console.error('❌ No matching variant found for options:', selectedOptions);
          }
        } catch (error) {
          console.error('❌ Error fetching product data:', error);
        }
      });
    });
  });
});
